import HomeRedirectScreen from '@dms/screen/home/redirect'

export default HomeRedirectScreen
